import { render, staticRenderFns } from "./ServiceClasses.vue?vue&type=template&id=1ca7d802&scoped=true"
import script from "./ServiceClasses.vue?vue&type=script&lang=js"
export * from "./ServiceClasses.vue?vue&type=script&lang=js"
import style0 from "./ServiceClasses.vue?vue&type=style&index=0&id=1ca7d802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7d802",
  null
  
)

export default component.exports